// extracted by mini-css-extract-plugin
export default {"modal":"EditClientContactDetails_modal__YR-GI","form":"EditClientContactDetails_form__n2cRW"};